import { createReducer, on } from "@ngrx/store";
import { RoleState, initializeRoleState } from "./role.state";
import { GetAdministratorRoles, GetAdministratorRolesSuccess, GetAdministratorRolesError } from "./role.actions";
import { Roles } from "src/app/constants/Roles";

export const RoleReducers = createReducer(
  initializeRoleState,
  on(GetAdministratorRoles, (state): RoleState => {
    return {
      ...state,
      loading: true
    };
  }),
  on(GetAdministratorRolesSuccess, (state, action): RoleState => {
    // Add SystemAdministrator on the AdminRole since API will not include it on the response
    let actionResult = action.result.map((adminRole) => ({
      ...adminRole
    }));
    
    if (actionResult.findIndex(ar => ar.id === Roles.SystemAdministrator) < 0) {
      actionResult.push({
        id: Roles.SystemAdministrator,
        name: Roles.SystemAdministrator.toString()
      })
    }

    return {
      ...state,
      loading: false,
      list: actionResult
    }
  }),
  on(GetAdministratorRolesError, (state, action): RoleState => {
    return {
      ...state,
      loading: false,
      error: action.error
    }
  })
)